import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=4c2f3134&"
import script from "./AddressEdit.vue?vue&type=script&lang=js&"
export * from "./AddressEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports